export function addInhibitKeysListener() {
	if(window.xs_inhibitKeysListener) {
		window.removeEventListener('keydown', window.xs_inhibitKeysListener);
	}
	window.xs_inhibitKeysListener = function (e) {
		try {
			const evt = window.event? window.event : e;
			switch(evt.keyCode) {
				case 116: {
					e.preventDefault();
					e.stopPropagation();
					console.debug("F5 key pressed: inhibited!");
					break;
				}
				case 27: {
					e.preventDefault();
					e.stopPropagation();
					console.debug("ESC key pressed: inhibited!");
					break;
				}
				default:
					break;
			}
		}catch(err) {
			console.error(err);
		}
		
	}
	if(window.xs_inhibitKeysListener) {
		window.addEventListener('keydown', window.xs_inhibitKeysListener);
	}
}
